import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import KoochiLogo from '../../../../inc/assets/images/logo/koochi-logo.png';
import { handleChangeInputLoginPage, handleChangeProfileData, handleChangeToken } from '../../../../redux/actions/pages/user/login';
import { handleChangeTimerTimePageVerification, 
    handleChangeInputVerificationPage } from "../../../../redux/actions/pages/user/verification";
import { LOGIN_POST, USERS_ACTIVATION_POST } from '../../../../apis'; 
// import ReCAPTCHA from "react-google-recaptcha";
import apiRequest from '../../../../utils/apiRequest'; 

const Verify = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();


	const { mobile } = useSelector(state => state.login);
	const { isBackdropLoading } = useSelector(state => state.allLoaders);
	const { code, timerTime } = useSelector(state => state.verification);
	const disableBtn = isBackdropLoading || code.length !== 4;


	useEffect(() => {
        handleTimerTime();
        // eslint-disable-next-line
    }, [timerTime]);

    useEffect(() => {
        if(code.length === 4 && !isBackdropLoading)
        	apiActivation();
        // eslint-disable-next-line
    }, [code]);

    let setTimeOut;
    const handleTimerTime = () => {
        if (timerTime > 0)
            setTimeOut = setTimeout(() => {
                if (timerTime > 0) {
                    dispatch(handleChangeTimerTimePageVerification(timerTime - 1));
                } else
                    clearTimeout(setTimeOut);
            }, 1000);
        else {
            if (timerTime !== 0)
                dispatch(handleChangeTimerTimePageVerification(0));
        }
    };

    const handleChangeInputs = (event) => {
        const {name, value} = event.target;
        dispatch(handleChangeInputVerificationPage(name, changeNumberPersianAndArabic(value)));
    };

    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    }

    const apiLogin = () => {
    	if(! isBackdropLoading) {
    		apiRequest({
			    dispatch,
			    endpoint: LOGIN_POST,
			    method: 'post',
			    data: { mobile },
			    token: null,
			    successMessage: null,
			    onSuccess: (res) => {
                    dispatch(handleChangeTimerTimePageVerification(parseInt(res.timer_time)));
			    },
		  	});
    	}
    };



    const userAgent = navigator.userAgent;
	let browser = 'Unknown';

	if (userAgent.includes('Firefox')) {
	  	browser = 'Firefox';
	} else if (userAgent.includes('Chrome')) {
	  	browser = 'Chrome';
	} else if (userAgent.includes('Safari')) {
	  	browser = 'Safari';
	} else if (userAgent.includes('Edge')) {
	  	browser = 'Edge';
	} else if (userAgent.includes('Opera')) {
	  	browser = 'Opera';
	} else if (userAgent.includes('MSIE')) {
	  	browser = 'Internet Explorer';
	}

	const deviceInfo = JSON.stringify({
	  	app_version: process.env.REACT_APP_VERSION, // یا نسخه ای که خودتان تعریف می‌کنید
	  	languages: navigator.languages || [navigator.language],
	  	plugins: Array.from(navigator.plugins).map(plugin => plugin.name),
	  	userAgent: navigator.userAgent,
	  	cpuCores: navigator.hardwareConcurrency,
	  	deviceMemory: navigator.deviceMemory,
	  	timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
	  	touchSupport: 'ontouchstart' in window,
	  	doNotTrack: navigator.doNotTrack,
	  	cookieEnabled: navigator.cookieEnabled,
	  	online: navigator.onLine
	});

    const apiActivation = (event = null) => {
    	if(event !== null)
    		event.preventDefault();

    	if(! isBackdropLoading) {
    		if(code.length === 0) {
	    		dispatch(handleChangeInputVerificationPage('inputClass', 'Input-InputWrapper-error'));
	    		dispatch(handleChangeInputVerificationPage('errorTxt', 'لطفا این قسمت را خالی نگذارید!'));
	    	}
	    	else if(code.length !== 4) {
	    		dispatch(handleChangeInputVerificationPage('inputClass', 'Input-InputWrapper-error'));
	    		dispatch(handleChangeInputVerificationPage('errorTxt', 'کد باید  4 رقم باشد!'));
	    	}
	    	else {
	    		dispatch(handleChangeInputVerificationPage('inputClass', 'Input-InputWrapper-d'));
	    		dispatch(handleChangeInputVerificationPage('errorTxt', ''));


	    		apiRequest({
				    dispatch,
				    endpoint: USERS_ACTIVATION_POST,
				    method: 'post',
				    data: { 
				    	code, 
				    	mobile, 
				    	width: window.screen.width, 
				    	height: window.screen.height, 
				    	platform: navigator.platform,
				    	browser,
				    	deviceInfo
				    },
				    token: null,
				    successMessage: null,
				    onSuccess: (res) => {
				      	dispatch(handleChangeInputVerificationPage('code', ''));
                        dispatch(handleChangeInputVerificationPage('timerTime', 0));

                        dispatch(handleChangeInputLoginPage('mobile', ''));

                        dispatch(handleChangeProfileData(res.info));
                        dispatch(handleChangeToken(res.token));
				    },
			  	});
	    	}
    	}
    };

    const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};


    return (


		<div className="app-content  container-fluid">
  			<div className="content-wrapper">
    			<div className="content-header row">
    			</div>
    			<div className="content-body">
    				<section className="flexbox-container">
						<div className="col-md-6 col-lg-4 offset-md-3 offset-lg-4 col-xs-12 offset-xs-0  box-shadow-2 p-0">
    						<div className="card border-grey border-lighten-3 m-0" style={{minHeight: 'unset !important'}} >
        						<div className="card-header no-border">
            						<div className="card-title text-xs-center">
                						<div className="p-1">
                							<img src={KoochiLogo} alt="branding logo" width="150" />
                						</div>
        							</div>
        							<h6 className="card-subtitle line-on-side text-muted text-xs-center font-small-3 pt-2"><span>صفحه ورود به پنل فروشنده</span></h6>
        							<h6 className="card-subtitle text-muted text-xs-center font-small-3 pt-2"><span>تماس با پشتیبانی: <a href="tel:+989391019323" style={{color: '#0100fe'}}>{toPersianDigits("9323 101 0939")}</a></span></h6>
    							</div>
        						<div className="card-body collapse in">
            						<div className="card-block">
            							<form className="form-horizontal form-simple" onSubmit={apiActivation}>
            								<fieldset className="form-group position-relative  mb-1">
					                            کد تایید برای شماره  {toPersianDigits(mobile)} پیامک شد!
					                        </fieldset>
					                        <fieldset className="form-group position-relative has-icon-left ">
					                            <input type="number" name="code" value={code} onChange={handleChangeInputs} className="form-control form-control-lg input-lg" id="user-name" placeholder="کد" style={{textAlign: 'center', letterSpacing: '1rem', paddingRight: 'unset'}}/>
					                            
					                        </fieldset>


	                    					<button type="submit" name="register_btn" value="login" disabled={disableBtn} className="btn btn-primary btn-lg btn-block"><i className="icon-unlock2 mr-1"></i> فالسازی</button>
                						</form>
            						</div>
        						</div>
					            <div className="card-footer">
					                <div className="">
					                    { timerTime === 0 ?
					                    	<p onClick={apiLogin} className="float-sm-left text-xs-left m-0">ارسال مجدد کد</p>
											:
											<p className="float-sm-left text-xs-left m-0 text-muted">
												<span className="mr-1">{timerTime}</span>
												ثانیه مانده تا دریافت مجدد کد
											</p>
										}
										<p onClick={() => navigate(-1)} className="float-sm-left text-xs-left mt-2">
											شماره موبایل را  اشتباه وارد کرده اید؟
										</p>
					                </div>
					            </div>
    						</div>
						</div>
					</section>

    			</div>
  			</div>
		</div>



    );
}

export default Verify;